import { useEffect, useState } from 'react';

import { Box, Text, TextButton } from '@opendoor/bricks-next';
import { push } from 'connected-react-router';

import { sellerGlobalPagePath } from 'src/routes/pathBuilders';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';

import { GOOGLE_MAPS_API_KEY } from '../../helpers/globals';

const AddressMapElement: React.FC = () => {
  const dispatch = useAppDispatch();
  const address = useAppSelector((state) => state.sellerInput.address);
  const token = useAppSelector((state) => state.sellerInput.leadToken);
  const isAddressEntryConfirmationTreatment = useAppSelector(
    (state) => state.experimentFlags.addressEntryConfirmation === 'treatment',
  );
  const [backgroundURL, setBackgroundURL] = useState('');
  const streetViewMetaUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?size=600x300&location=${address.lat},${address.lng}&fov=90&heading=235&pitch=10&key=${GOOGLE_MAPS_API_KEY}`;
  const streetViewURL = `https://maps.googleapis.com/maps/api/streetview?size=640x300&location=${address.lat},${address.lng}&source=outdoor&key=${GOOGLE_MAPS_API_KEY}`;
  const mapURL = `https://maps.googleapis.com/maps/api/staticmap?center=${address.lat},${address.lng}&scale=2&size=640x300&zoom=16&key=${GOOGLE_MAPS_API_KEY}&style=feature:all|element:labels|visibility:off&style=feature:administrative.land_parcel|element:all|visibility:off&style=feature:administrative.neighborhood|element:all|visibility:off&style=feature:landscape.man_made|element:geometry.fill|color:0xebe9e7&style=feature:poi.school|element:geometry.fill|color:0xebe9e7&style=feature:road|element:geometry.fill|color:0xffffff`;
  useEffect(() => {
    const checkStreetView = async () => {
      try {
        const response = await fetch(streetViewMetaUrl);
        const metadata = await response.json();
        if (metadata.status === 'OK') {
          setBackgroundURL(`url(${streetViewURL})`);
        } else {
          setBackgroundURL(`url(${mapURL})`);
        }
      } catch {
        setBackgroundURL(`url(${mapURL})`);
      }
    };
    checkStreetView();
  }, [streetViewMetaUrl, streetViewURL, mapURL]);

  return (
    <>
      <Box
        position="relative"
        height={300}
        $smallerThanMD={{
          height: 165,
        }}
        width="100%"
        borderRadius="$10x"
        backgroundColor="$backgroundStateHoverPrimary"
        style={{
          backgroundImage: backgroundURL,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        {backgroundURL.includes('staticmap') && (
          <Box position="absolute" width="100%" bottom="calc(50% - 6px)">
            <Box
              style={{
                filter: 'drop-shadow(0 1.2px 6px rgba(29, 71, 123, 0.12))',
              }}
              display="flex"
              alignItems="center"
              gap={0}
              margin="auto"
            >
              <Box backgroundColor="$backgroundInversePrimary" padding="$5x" borderRadius="$12x">
                <Text
                  tag="p"
                  typography="$bodySmall"
                  fontWeight="500"
                  color="$contentInversePrimary"
                >
                  {address.street1}
                </Text>
              </Box>
              <Text
                tag="p"
                marginTop={-6}
                typography="$bodySmall"
                fontWeight="500"
                color="$backgroundInversePrimary"
              >
                <svg
                  width="17"
                  height="12"
                  viewBox="0 0 17 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1519 10.4666L16.0969 4.30772C17.5782 2.77313 16.4907 0.211914 14.3578 0.211914H2.65587C0.541537 0.211914 -0.553736 2.73497 0.890066 4.27958L6.64699 10.4385C7.59187 11.4494 9.1909 11.4622 10.1519 10.4666Z"
                    fill="currentColor"
                  />
                </svg>
              </Text>
            </Box>
          </Box>
        )}
      </Box>
      {!isAddressEntryConfirmationTreatment && (
        <TextButton
          size="small"
          variant="primary"
          analyticsName="reception-edit-address"
          // goto address verification page
          onPress={() => {
            dispatch(push(sellerGlobalPagePath({ token, page: 'address-manual' })));
            return false;
          }}
          // otherwise this thing submits...
          label="Edit Address"
        />
      )}
    </>
  );
};

export default AddressMapElement;
